export default function postRegister() {
    // eslint-disable-next-line no-console
    console.log('Hello, ADP!');
}
